export type EventCallback = (...args: any[]) => void;

export class EventManager {
    private _listeners: Map<string, EventCallback[]> = new Map();
    
    /**
     * Add event listener
     */
    on(event: string, callback: EventCallback): void {
        if (!this._listeners.has(event)) {
            this._listeners.set(event, []);
        }
        this._listeners.get(event)!.push(callback);
    }
    
    /**
     * Remove event listener
     */
    off(event: string, callback: EventCallback): void {
        if (!this._listeners.has(event)) return;
        
        const callbacks = this._listeners.get(event)!;
        const index = callbacks.indexOf(callback);
        if (index !== -1) {
            callbacks.splice(index, 1);
        }
    }
    
    /**
     * Emit event
     */
    emit(event: string, ...args: any[]): void {
        if (!this._listeners.has(event)) return;
        
        const callbacks = this._listeners.get(event)!;
        callbacks.forEach(callback => {
            try {
                callback(...args);
            } catch (error) {
                console.error(`Error in event listener for '${event}':`, error);
            }
        });
    }
    
    /**
     * Remove all listeners for an event
     */
    removeAllListeners(event?: string): void {
        if (event) {
            this._listeners.delete(event);
        } else {
            this._listeners.clear();
        }
    }
    
    /**
     * Get listener count for an event
     */
    listenerCount(event: string): number {
        return this._listeners.get(event)?.length || 0;
    }
} 